export const COMPANIES_SLUG = 'companies';
export const REPORTS_SLUG = 'reports';
export const DASHBOARD_SLUG = 'dashboard';
export const OVERVIEW_SLUG = 'overview';
export const PREVIOUS_REPORTS_SLUG = 'previous-reports';
export const SETTINGS_SLUG = 'settings';
export const SUBSCRIPTION_SLUG = 'subscription';
export const INFORMATION_SLUG = 'information';
export const OPERATIONS_SLUG = 'operations';

export const COMPANY_DETAILS_SLUGS = [SUBSCRIPTION_SLUG];

export const WORKBOARD_SLUG = 'workboard';
export const CURRENT_JOBS_SLUG = 'current-jobs';
export const PAST_JOBS_SLUG = 'past-jobs';
export const OPPORTUNITIES_SLUG = 'opportunities';
export const MODELS_SLUG = 'models';

// Analyst tab titles
export const CURRENT_JOBS_TITLE = 'Current Jobs';
export const PAST_JOBS_TITLE = 'Past Jobs';
export const OPPORTUNITIES_TITLE = 'Opportunities';
export const MODELS_TITLE = 'Models';

// Analyst tab mapping dictionary
export const WORKBOARD_TAB_TITLES: Record<string, string> = {
  [CURRENT_JOBS_SLUG]: CURRENT_JOBS_TITLE,
  [PAST_JOBS_SLUG]: PAST_JOBS_TITLE,
  [OPPORTUNITIES_SLUG]: OPPORTUNITIES_TITLE,
  [MODELS_SLUG]: MODELS_TITLE,
};
